(function FranchiseListReview($, Adzuki)
{
	"use strict";

	Adzuki.onload('FranchiseLists/review/', init, false);

	function init()
	{
		var selected_client_ids = $('#franchiselistreview-clients_in_list').val().join();
		$('#franchiselistreviewsearch-selected_clients').val(selected_client_ids);

		$('#clearSearch').on('click', handleClearSearch);
		$('#sort-results').on('change', handleSort);

		$('.hidden_multiselect select').on('countChanged', handleListChange);
	}

	function handleListChange(event, count)
	{
		var num_allowed, remaining;

		var show_allotment_messages = parseInt($('#franchiselistreview-show_allotment_messages').val());

		// Update the search form hidden selected clients
		var selected_client_ids = $('#franchiselistreview-clients_in_list').val().join();
		$('#franchiselistreviewsearch-selected_clients').val(selected_client_ids);

		num_allowed = parseInt($('#franchiselistreview-num_clients_allowed').val());
		// Update/display text if they are short of their allotment
		if (show_allotment_messages && count > num_allowed) {
			$('#over-allotment-warning').show();
		} else {
			$('#over-allotment-warning').hide();
		}

		if (show_allotment_messages && count < num_allowed) {
			remaining = num_allowed - count;
			$('#under-allotment-number').text(remaining);
			$('#under-allotment-message').show();
		} else {
			$('#under-allotment-message').hide();
		}
	}

	function handleClearSearch(ev)
	{
		ev.preventDefault();
		$('#franchiselistreviewsearch-clear_search').val(1);
		$('#FranchiseListReviewSearchForm').submit();
	}

	function handleSort(ev)
	{
		var franchise_list_id, sort_by, selected_client_ids, all_client_ids, from_label;

		sort_by = this.value;
		franchise_list_id = $('#franchiselistreview-id').val();
		selected_client_ids = $('#franchiselistreview-clients_in_list').val().join();
		$('#franchiselistreview-clients_in_list option').prop('selected', true);
		all_client_ids = $('#franchiselistreview-clients_in_list').val().join();
		from_label = $('#move-between-from-label').html();

		$('#move-between-lists-container').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Sorting Clients');

		Adzuki.Ajax.post('/FranchiseLists/sortClients', {
			franchise_list_id  : franchise_list_id,
			sort_by            : sort_by,
			selected_client_ids: selected_client_ids,
			all_client_ids     : all_client_ids,
			from_label         : from_label,
		}).then(function success(response) {
			$('#move-between-lists-container').html($($.parseHTML(response)).find('#move-between').html());
			Adzuki.MoveBetweenLists.init();
		});
	}

}(jQuery, window.Adzuki || {}));
